// 📄 components/common/MetricCard.tsx
// Card pequeña de métrica (icono + valor + label) — usada en ProjectStatsPanel
// (GeneralStatsView y SolutionStatsView).
import React from 'react';

interface MetricCardProps {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  value: number | string;
  variant?: 'default' | 'danger';
}

export default function MetricCard({ icon: Icon, label, value, variant = 'default' }: MetricCardProps) {
  const valueColor = variant === 'danger' && Number(value) > 0 ? 'text-red-400' : 'text-white';
  return (
    <div className="bg-white/5 border border-white/10 rounded-xl p-4 flex flex-col gap-2">
      <Icon className="w-4 h-4 text-gray-400" />
      <span className={`text-2xl font-bold ${valueColor}`}>{value}</span>
      <span className="text-xs text-gray-400">{label}</span>
    </div>
  );
}
